/**
 * Option lists for logistics provider profile (Capabilities / Transport).
 * Keep in sync with `pages/Profile Management/logistics_provider_profile.js`.
 */

export const LOGISTICS_COMPANY_TYPE_OPTIONS = [
  { value: "", label: "Select company type" },
  { value: "Asset Owner", label: "Asset Owner" },
  { value: "Aggregator", label: "Aggregator" },
  { value: "Broker", label: "Broker" },
  { value: "Fleet Owner", label: "Fleet Owner" },
  { value: "NVOCC", label: "NVOCC" },
  { value: "Freight Forwarder", label: "Freight Forwarder" },
  { value: "Carrier", label: "Carrier" },
  { value: "Multimodal Operator", label: "Multimodal Operator" },
];

/** For filters / selects (no empty placeholder row). */
export const LOGISTICS_COMPANY_TYPE_FILTER_OPTIONS = LOGISTICS_COMPANY_TYPE_OPTIONS.filter((o) => o.value !== "");

/** Transport mode ids — same as profile `transport_modes.modes` (uses `id` in UI). */
export const LOGISTICS_TRANSPORT_MODES = [
  { id: "road", label: "Road", icon: "🚚" },
  { id: "ocean", label: "Ocean", icon: "🚢" },
  { id: "rail", label: "Rail", icon: "🚆" },
  { id: "air", label: "Air", icon: "✈️" },
  { id: "multimodal", label: "Multimodal", icon: "🌐" },
];

/** Profile → Capabilities → Industries served (string array). */
export const LOGISTICS_INDUSTRIES_SERVED = [
  "FMCG",
  "Pharmaceuticals",
  "E-commerce",
  "Automotive",
  "Retail",
  "Manufacturing",
  "Electronics",
  "Textiles",
  "Agriculture",
  "Chemicals",
  "Machinery",
  "Construction",
];

/** Profile → Capabilities → Core specialization. */
export const LOGISTICS_CORE_SPECIALIZATION = [
  "International Freight",
  "Door-to-Door Delivery",
  "Project Cargo",
  "Warehousing",
  "Hazardous Materials",
  "White Glove Service",
  "Customs Clearance",
  "Cold Chain Logistics",
  "Express Delivery",
  "Last Mile Delivery",
  "Temperature Control",
  "Cross-Border Trade",
];

/** Profile → Capabilities → Special cargo. */
export const LOGISTICS_SPECIAL_CARGO = [
  "Dangerous Goods",
  "Reefer / Cold Chain",
  "Oversized Cargo",
  "Perishables",
  "High-Value Security",
  "Live Animals",
  "Pharma Cold Chain",
  "Fragile Goods",
];

/**
 * Union of preferred shipment type strings from profile transport tab
 * (`preferredShipmentTypeOptions` logic).
 */
export const LOGISTICS_PREFERRED_SHIPMENT_TYPES = [
  "FTL",
  "LTL",
  "PTL",
  "FCL",
  "LCL",
  "Express Air Cargo",
  "Rail Cargo",
  "Door-to-Door",
];

/** Preferred shipment types available for the selected transport modes (profile transport tab). */
export const getPreferredShipmentTypesForModes = (selectedModes = []) => {
  const modes = Array.isArray(selectedModes) ? selectedModes : [];
  const opts = [];
  const push = (value) => {
    if (!value || opts.includes(value)) return;
    opts.push(value);
  };
  if (modes.includes("road")) ["FTL", "LTL", "PTL"].forEach(push);
  if (modes.includes("ocean")) ["FCL", "LCL"].forEach(push);
  if (modes.includes("air")) push("Express Air Cargo");
  if (modes.includes("rail")) push("Rail Cargo");
  if (modes.includes("multimodal")) push("Door-to-Door");
  return opts;
};
